<template>
  <section id="admin-filter">
    <h4>Calculation filter</h4>
    <div class="form-group">
      <label for="filter-calc-code" class="form-label">Code</label>
      <input type="text" class="form-control" id="filter-calc-code" v-model="entity.code"/>
    </div>
    <div class="form-group">
      <label for="filter-calc-name" class="form-label">Name</label>
      <input type="text" class="form-control" id="filter-calc-name" v-model="entity.name"/>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  export default {
    name: 'CalculationFilter',
    data () {
      return {
        entity: {
          code: '',
          name: ''
        }
      }
    },
    mixins: [ FilterMixin ]
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Calculation/CalculationFilter.vue